'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagNiAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 0C9.33333 0 18.6667 -0.000124129 28 1.31726e-05V20C18.6667 20 9.33333 20 1.78814e-06 20C1.78814e-06 13.3333 1.33131e-05 6.66667 0 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.78814e-06 6.66667H28V1.31726e-05L0 0L1.78814e-06 6.66667Z",
          fill: "#1A78D6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.78814e-06 20H28V13.3333H1.78814e-06V20Z",
          fill: "#1A78D6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.6667 10C16.6667 11.4728 15.4728 12.6667 14 12.6667C12.5272 12.6667 11.3333 11.4728 11.3333 10C11.3333 8.52724 12.5272 7.33333 14 7.33333C15.4728 7.33333 16.6667 8.52724 16.6667 10ZM16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10C12 8.89543 12.8954 8 14 8C15.1046 8 16 8.89543 16 10Z",
          fill: "#DBCD92"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9998 8.66669L15.3332 11.3334H12.6665L13.9998 8.66669Z",
          fill: "#9CDDEE"
        }
      )
    ]
  }
);
const VpFlagNiAsset = forwardRef(FlagNiAsset);

export { VpFlagNiAsset as default };
